<template>
	<Body class="center-title" />
    <BasePublishDetail :root-category="true" v-slot="{item}">
		<div :class="['publish-detail', !item?.main_image_upload_path && 'pd-no-image']">
            <div class="publish-wrapper wider-wrapper">
                <div class="publish-intro">
                    <CmsBreadcrumbs v-if="item?.breadcrumbs" :items="item.breadcrumbs" />
                    <h1 class="pd-title">{{ item.seo_h1 }}</h1>
                </div>

                <div class="publish-details">
                    <div v-if="item?.main_image_upload_path" class="pd-images">
                        <div class="pd-hero-image">
                            <span>
                                <BaseUiImage :data="item.main_image_thumbs?.['width1200-height750-crop1']"  default="/images/no-image-1200.jpg" :alt="item.main_image_description" />
                            </span>
                        </div>
                    </div>
                    <div class="pd-date-comments">
                        <div class="pd-date">
                            <span class="value"><BaseUtilsFormatDate :date="item.datetime_published" format="DD. MMMM YYYY." /></span>
                        </div>
                    </div>
       
                    <div class="cms-content">
                        <div v-if="item.content" v-html="wrapInnerBtn(item.content)" v-interpolation></div>

                        <ul v-if="item.documents?.length" class="pd-documents">
                            <li v-for="document in item.documents" :key="document.id">
                                <a :href="document.url" target="_blank">{{document.title}}</a>
                            </li>
                        </ul>

                        <div v-if="item?.images?.length > 1" class="pd-thumbs">                             
                            <BaseUiImage v-for="image in item.images" :key="image.id" loading="lazy" :data="image.file_thumbs?.['width920-height450-crop1']" :alt="image.description" />
                        </div>
                    </div>

                    <ClientOnly>
                        <LazyBaseCatalogProductsWidget :fetch="{related_publish_id: item.id, limit: 8}" v-slot="{items}">
                            <div class="pd-rp-items" v-if="items?.length">
                                <template v-for="item in items" :key="item.id">
                                    <CatalogIndexEntryMenu :item="item" mode="pd" />
                                </template>
                            </div>
                        </LazyBaseCatalogProductsWidget>
                    </ClientOnly>                    

                    <div v-if="item?.seo_keywords_tags?.length" class="pd-tags">
                        <template v-for="tag in item.seo_keywords_tags" :key="tag.id">
                            <NuxtLink class="pd-tag" :to="tag.url">
                                {{tag.title}}
                            </NuxtLink>
                        </template>
                    </div>

                    <ClientOnly>
                        <CmsShare />
                    </ClientOnly>
                </div>

            </div>
        </div>          
        <div class="pd-comments" v-if="item.feedback_comment_widget">
            <div class="wrapper publish-wrapper">
                <BaseCmsLabel code="comments" class="pd-comments-title" tag="div" />
                <ClientOnly>
                    <FeedbackCommentsForm :item="item" mode="pd" />
                </ClientOnly>                
            </div>
        </div>       
        <BasePublishPostsWidget :fetch="{category_code: 'advices', limit: 3, id_exclude: item?.id, extra_fields: ['short_description'], response_fields: ['id', 'url_without_domain', 'title', 'main_image_thumbs', 'short_description']}" v-slot="{items}">
            <div class="pd-related" v-if="items.length">
                <div class="wider-wrapper">
                    <h2 class="pd-related-title"><BaseCmsLabel code="publish_related" /></h2>
                    <div class="blog-cnt pd-blog-cnt p-items">
                        <PublishIndexEntry v-for="post in items" :item="post" :key="post.id" />
                    </div>
                    <div class="show-all">
                        <NuxtLink :to="item.category_url_without_domain" class="btn btn-secondary btn-show-articles"><BaseCmsLabel code="show_all_articles" /></NuxtLink>
                    </div>
                </div>
            </div>
        </BasePublishPostsWidget>    
	</BasePublishDetail>
</template>

<style lang="less" scoped>
    .page-publish-detail{
        .cms-content{
            font-weight: 400;
            :deep(ul){
                li{font-weight: 400;}
            }
            :deep(h2){font-weight: bold;}
        }
    }
    .publish-detail{
        padding: 40px 0 55px;
        .bc{
            :deep(a){
                &:nth-child(2){display: none;}
            }
        }
    }
    .publish-intro{
        padding-bottom: 20px; text-align: center;
        .bc{padding-bottom: 10px;}
        h1{font-size: 38px; line-height: 52px; padding-bottom: 5px; font-weight: bold;}
    }
    .publish-wrapper{
        margin: 0 auto; width: 920px;
        .cms-content{padding: 0;}
    }
    .pd-images{padding-bottom: 30px;}
    .pd-hero-image{ 
        position: relative;
        &:before{.pseudo(auto,auto); background: url(assets/images/bg-main.jpg) top left; background-size: cover; left: -1000px; right: -1000px; top: -202px; bottom: 60px; z-index: -1;}
        :deep(img){display: block; width: calc(~"100% - -280px"); height: auto; margin-left: -140px; box-shadow: 0 30px 40px 0 rgba(85,41,122,.15); max-width: none;}
    }
    .btn-comment-new{margin: 0; padding: 0 15px;}
    .pd-date-comments{display: flex; color: rgba(43,44,55,0.5); align-items: center; padding-bottom: 17px; font-size: 18px;}
    .pd-date{margin-right: 17px;}
    .pd-comments{
        .publish-wrapper{margin: 0 auto;}
    }
    .pd-comments-label-value{
        a{font-weight: 300; font-size: 15px;}
    }
    .pd-no-image{
        .publish-intro{ position: relative; padding-bottom: 30px;
            &:before{.pseudo(auto,auto); background: url(assets/images/bg-main.jpg) top left; background-size: cover; left: -1000px; right: -1000px; top: -183px; bottom: 30px; z-index: -1;}
        }
        h1{padding-bottom: 35px;}
    }
    .pd-documents{
        padding-left: 0 !important;
        li{
            min-height: 45px !important; line-height: 45px !important; border-bottom: 1px solid var(--borderColor); padding-left: 30px !important;
            &:before{ .pseudo(20px,20px) !important; left: 0; top: 16px !important; font: 20px/20px var(--fonti) !important; .icon-pdf !important; background: white !important;}
        }
        a{display: block;}
    }

 	:deep(.pd-rp-items){
		margin: 20px 0 25px;
        .cp{display: flex; margin: -1px 0 0 0; width: 100%; flex-flow: row; align-items: center;}
		.cp-image{
			display: flex; align-items: center; justify-content: center; width: 168px; flex-shrink: 0; position: relative; aspect-ratio: 1;
			a{width: 100%; height: 100%; padding: 0; margin: 0;}
			img{width: auto; height: auto; max-width: 100%; max-height: 100%;}
		}

		.cp-badges-container{top: 10px; left: 10px; background: transparent; padding: 0;}
		.cp-badge-cnt{background: var(--white); padding: 3px; position: relative; bottom: auto;}
		.cp-badge-discount{font-size: 19px; line-height: 20px;}
		.cp-save{font-size: 8px; line-height: 10px; display: none;}
		.cp-cnt-bottom-price{display: block;}
		.cp-badge-image{width: 38px; height: 38px;}


        .cp-cnt{display: flex; padding: 10px 32px 10px 0; flex-flow: row; align-items: center;}
        .cp-cnt-top{flex: 1 1 auto; padding-right: 40px;}

        .cp-brand{padding: 0; text-align: left; font-size: 16px; line-height: 22px; font-weight: bold;}
        .cp-title{text-align: left; padding: 4px 0 0; width: auto; font-size: 18px; line-height: 22px;}

        .cp-cnt-bottom{display: flex; flex-wrap: wrap; flex: 0 0 240px; justify-content: flex-end;}
        .cp-cnt-bottom-price{width: 100%; padding-bottom: 15px;}
        .cp-price{text-align: right; padding: 0; width: auto;}
        .cp-unit-desc{text-align: right;}
        .cp-discount-price, .cp-current-price{font-size: 20px;}
        .cp-extra-price-lowest{
            text-align: right;
            strong{display: inline;}
        }

		.cp-wishlist{
            position: relative; top: auto; right: auto; flex: 0 0 48px; width: 48px; height: 48px; border: 1px solid #DFDFDF; display: flex; align-items: center; justify-content: center; border-radius: 2px; margin-right: 10px; .transition(border-color);
            @media (min-width: @h){
                &:hover{border-color: var(--primaryColor);}
            }
        }
        .cp-qty-add{margin: 0; width: auto; flex: 0 0 168px;}
		.cp-btn-addtocart{
			width: 48px; height: 48px; font-size: 0;
			span{padding-left: 0; width: 22px; height: 22px;}
		}
	}   

    .pd-tags{display: flex; flex-wrap: wrap; padding: 15px 0 0;}
    .pd-tag{
        display: block; border: 1px solid #DFDFDF; border-radius: 2px; font-size: 16px; padding: 5px 12px 3px 33px; text-decoration: none; color: var(--textColor); margin: 0 8px 8px 0; position: relative; .transition(border-color,0.3s);         &:before{position: absolute; .icon-tag; font: 18px/18px var(--fonti); color: var(--primaryColor); left: 8px; top: 8px;}
        @media (min-width: @h){
            &:hover{border-color: var(--primaryColor);} 
        }
    }

    @media (max-width: @l){
        .publish-wrapper{width: 920px;}
    }
    @media (max-width: @t){
        .publish-detail{padding: 40px 0 55px;}
        .publish-wrapper{width: auto; margin: 0 180px;}
        .pd-images{padding-bottom: 20px;}
        .pd-date-comments{font-size: 16px; padding-bottom: 13px;}
        .pd-hero-image{
            :deep(img){width: calc(~"100% - -190px"); margin-left: -95px;}
            &:before{top: -160px; bottom: 185px;}
        }
        .publish-intro{padding-bottom: 13px;
            .bc{padding-bottom: 6px;}
            h1{font-size: 30px; line-height: 39px;}
        }

        .pd-documents{
            li{min-height: 38px !important; line-height: 38px !important; padding-left: 28px !important;
                &:before{width: 18px !important; height: 18px !important; top: 11px !important; font: 18px/18px var(--fonti); left: 0; }
            }
        }
        .pd-comments{
            .publish-wrapper{margin: 0 180px;}
        }        
        :deep(.pd-rp-items){
            .cp-image{width: 128px;}
            .cp-cnt-top{padding-right: 10px;}
            .cp-brand{font-size: 14px;}
            .cp-title{font-size: 14px; line-height: 18px; padding-top: 1px;}
            .cp-discount-price, .cp-current-price{font-size: 16px; line-height: 20px;}
        }
    }

    @media (max-width: @tp){
        .publish-detail{padding: 22px 0 45px;}
        .publish-wrapper{margin: 0 15px;}
        .pd-hero-image{
            &:before{bottom: 215px;}
            :deep(img){width: 100%; margin-left: 0;}
        }
        .publish-intro{padding-bottom: 13px;}
        .pd-images{padding-bottom: 17px;}
        .pd-date-comments{font-size: 16px; padding-bottom: 10px;}
        .pd-no-image{
            h1{padding-bottom: 22px;}
            .publish-intro{padding-bottom: 25px;}
        }

        .pd-comments{
            .publish-wrapper{margin: 0 15px; padding-right: 0;}
        }
        :deep(.pd-comments-title){font-size: 24px; line-height: 30px;}
        .publish-comments{padding: 22px 0 40px;}	
    }
    @media (max-width: @m){
        .page-publish-detail .cms-content{
            font-size: 18px; line-height: 23px;
            :deep(p){font-size: 18px; line-height: 23px;}
            :deep(ul){
                li{
                    font-size: 18px; line-height: 23px;
                    &:before{top: 10px;}
                }
            }
            :deep(.btn){height: 50px;}
        }
        .publish-detail{
            padding: 24px 0 40px;
            .image-title{
                padding: 8px 0 2px 18px; padding-bottom: 4px;
                &:before{top: 16px;}
            }
        }        
        .publish-intro{
            padding-bottom: 8px;
            .bc{padding-bottom: 8px; font-size: 13px; line-height: 16px;}
            h1{font-size: 20px; line-height: 26px; padding-bottom: 2px;}
        }
        .pd-images{padding-bottom: 10px;}
        .pd-hero-image{
            &:before{bottom: 100%; left: -15px; right: -15px;}
            :deep(img){margin-left: -15px; width: calc(~"100% - -30px"); box-shadow: none;}
        }
        .pd-date-comments{font-size: 14px; padding-bottom: 8px;}
        
        .publish-comments{padding: 18px 0 30px;}
        :deep(.comment-field-display_name){width: 100%; margin: 0;}
        :deep(.pd-comments-title){font-size: 20px; line-height: 26px;}
        :deep(.comment-field-email){width: 100%; margin: 0;}
        :deep(.comment-button-cnt){width: 100%; flex-wrap: wrap;}
        :deep(.comment-form-note){font-size: 14px; line-height: 20px; text-align: center;max-width: 290px; margin: 0 auto;}
        .pd-comments{
            .publish-wrapper{margin: 0 15px; padding-right: 0;}
        }  

        :deep(.pd-rp-items){
            margin: 16px 0 20px;
            .cp{align-items: flex-start;}
            .cp-image{
                min-height: 0;
                img{max-width: 104px;}
            }
            .cp-cnt{display: block; padding: 12px 16px 16px 0;}
            .cp-cnt-top{padding-right: 0;}
            .cp-title{font-size: 16px; line-height: 20px; padding-top: 1px;}
            .cp-cnt-bottom{justify-content: flex-start; padding-top: 8px;}
            .cp-cnt-bottom-price{padding-bottom: 8px;}
            .cp-price{text-align: left;}
            .cp-extra-price-lowest{margin: 0; text-align: left; max-width: none;}
            .cp-unit-desc{text-align: left;}
            .cp-wishlist{width: 44px; height: 44px; flex: 0 0 44px; margin-right: 8px;}
            .cp-qty-add{gap: 8px; flex: 0 0 auto;}
            .cp-qty{
                width: 80px;
                input{height: 44px; font-size: 16px;}
                .qty-btn{height: 44px; width: 32px;}
            }
            .cp-btn-addtocart{width: 44px; height: 44px;}
        }

    }
    @media (max-width: 356px){
        :deep(.pd-rp-items){
            .cp-wishlist{display: none;}
        }
    }
</style>